import isNil from 'lodash-es/isNil';

export namespace NilUtils {
  type Nil = null | undefined;
  type Step<In, Out> = (value: In) => Out | Nil;
  type BubbleResult<In, Out> = (value: In | Nil) => Out | null;

  export function bubbleNull<In, Out>(step1: Step<In, Out>): BubbleResult<In, Out>;
  export function bubbleNull<In, S1, Out>(step1: Step<In, S1>, step2: Step<S1, Out>): BubbleResult<In, Out>;
  export function bubbleNull<In, S1, S2, Out>(
    step1: Step<In, S1>,
    step2: Step<S1, S2>,
    step3: Step<S2, Out>
  ): BubbleResult<In, Out>;
  export function bubbleNull<In, S1, S2, S3, Out>(
    step1: Step<In, S1>,
    step2: Step<S1, S2>,
    step3: Step<S2, S3>,
    step4: Step<S3, Out>
  ): BubbleResult<In, Out>;
  export function bubbleNull<In, S1, S2, S3, S4, Out>(
    step1: Step<In, S1>,
    step2: Step<S1, S2>,
    step3: Step<S2, S3>,
    step4: Step<S3, S4>,
    step5: Step<S4, Out>
  ): BubbleResult<In, Out>;
  export function bubbleNull<In, SpetVal, Out>(...steps: Array<Step<SpetVal, SpetVal | Out>>): BubbleResult<In, Out> {
    return (val: In | Nil) => {
      return steps.reduce((acc: any, nextStep) => {
        if (isNil(acc)) {
          return null;
        }
        return nextStep(acc);
      }, val);
    };
  }
}



// WEBPACK FOOTER //
// ./src/module/Common/utils/NilUtils.ts